import PaymentsListModal from './PaymentsListModal';

export default PaymentsListModal;
